import { Box, Icon, Text, VStack } from '@chakra-ui/react';
import { GrUserWorker } from 'react-icons/gr';

export const DashboardCollecteView = () => {
  return (
    <Box height="full" display="flex" alignItems="center" justifyContent="center" pt="32">
      <VStack gap={4} p={6} bg="white" boxShadow="md" borderRadius="lg">
        <Icon>
          <GrUserWorker />
        </Icon>
        <Text fontSize="xl" fontWeight="bold" color="gray.700">
          Work in Progress
        </Text>
        <Text fontSize="md" color="gray.500">
          We're working hard to bring you something amazing. Stay tuned!
        </Text>
      </VStack>
    </Box>
  );
};

export default DashboardCollecteView;
